import { AmountUnit, MonetaryAmount } from "../../../currency/currencyTypes"

export type Debtor = Readonly<{
    id: number
    name: string
    type: DebtorType
}>

export enum DebtorType {
    SUPPLIER = "SUPPLIER",
    TENANT = "TENANT",
    COMPANY = "COMPANY",
}
export enum DebtorTypeFilter {
    ALL = "ALL",
    SUPPLIER = "SUPPLIER",
    TENANT = "TENANT",
    COMPANY = "COMPANY",
}

export type DebtorDetails = DebtorDetailsSupplier | DebtorDetailsMerchantOrCompany

type BaseDebtorDetails = Readonly<{
    id: number
    name: string
    address: string
    debitorNo: number
    totalAmount: MonetaryAmount
}>

type DebtorDetailsSupplier = BaseDebtorDetails &
    Readonly<{
        type: DebtorType.SUPPLIER
        merchants: DebtorDetailsMerchant[]
    }>

type DebtorDetailsMerchantOrCompany = BaseDebtorDetails &
    Readonly<{
        type: DebtorType.TENANT | DebtorType.COMPANY
        invoiceLines: (TransactionInvoiceLines | SubscriptionInvoiceLines)[]
    }>

export type DebtorDetailsMerchant = Readonly<{
    id: number
    name: string
    address: string
    debitorNo: number
    invoiceLines: (TransactionInvoiceLines | SubscriptionInvoiceLines)[]
}>

export type SubscriptionInvoiceLines = Readonly<{
    type: InvoiceLinesType.SUBSCRIPTION
    unit: AmountUnit
    name: string
    item: number
    price: MonetaryAmount
    totalAmount: MonetaryAmount
}>

export type TransactionInvoiceLines = Readonly<{
    type: InvoiceLinesType.TRANSACTION
    unit: TransactionUnit
    name: string
    productNumber: string
    item: number
    price: MonetaryAmount
    totalAmount: MonetaryAmount
    discount?: {
        percentage: {
            amount: string
            scale: number
        }
    }
}>

export enum InvoiceLinesType {
    SUBSCRIPTION = "SUBSCRIPTION",
    TRANSACTION = "TRANSACTION",
}

export enum TransactionUnit {
    ITEM = "ITEM",
}
